export const usersHeader = "רשימת משתמשים";
export const bituahLeumiHeader = "רשימת תשלומים לביטוח לאומי";
export const regDataHeader = "מידע סטטיסטי על שלבי רישום משתמשים";
export const completeDetailsHeader = "רשימת סוכנים";
export const partnersHeader = "שותפים";
export const invitedUsersHeader = "משתמשים דרך מנגנון חבר מביא חבר";
export const customersHeader = "לקוחות";
export const agentsIncomesHeader = "הכנסות סוכנים על בסיס חשבוניות";
export const receiptsHeader = "קבלות";
export const invoicesHeader = "חשבוניות";
export const unpaidAgentsHeader = "סוכנים שלא שילמו להם";
export const usersActionsHeader = "פעולות משתמשים";
export const usersClientActionsHeader = "פעולות משתמשים באתר";
export const paypalRequestsHeader = "תשלומי פייפאל";
export const transfersHeader = "העברות";
export const notificationsHeader = "מרכז התראות";
export const lawAgentsHeader = "סוכנים";
export const lawTransactionsHeader = "עסקאות";
export const aiReportHeader = "דוחות בינה מלאכותית";
